import React, { Fragment } from "react"
import { Dialog, Transition } from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/24/outline"
import VideoPlayer from "../video"

export default function VideoModal({ isOpen, setIsOpen, video }) {
	return (
		<Transition.Root
			show={isOpen}
			as={Fragment}
		>
			<Dialog
				as="div"
				className="fixed z-20 inset-0 overflow-y-auto"
				onClose={() => {
					setIsOpen(false)
				}}
			>
				<div className="flex items-start justify-center min-h-screen min-w-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 mx-auto">
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
					</Transition.Child>

					<span
						className="hidden sm:inline-block sm:align-middle sm:h-screen"
						aria-hidden="true"
					>
						&#8203;
					</span>
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						enterTo="opacity-100 translate-y-0 sm:scale-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100 translate-y-0 sm:scale-100"
						leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
					>
						<div className="inline-block text-left overflow-hidden shadow-xl transform transition-all mt-24 align-top w-full h-full">
							<div
								className="block pt-4 w-full mb-8 pr-2 sm:pr-8 lg:pr-[5.5rem]"
								onClick={() => {
									setIsOpen(false)
								}}
								role="button"
								tabIndex={0}
								onKeyDown={() => {
									setIsOpen(false)
								}}
							>
								<button
									className="shadow-none outline-none float-right"
									size="sm"
									tabIndex="-1"
								>
									<span className="sr-only">Close</span>
									<XMarkIcon className="text-white h-8 w-8 group-hover:text-gray-600" />
								</button>
							</div>

							<div className="h-full w-full mt-4 px-2 sm:px-8 lg:px-24">
								<VideoPlayer
									data={video}
									isAutoplay={true}
								/>
							</div>
						</div>
					</Transition.Child>
				</div>
			</Dialog>
		</Transition.Root>
	)
}
